import {
    CaretDoubleLeft,
    CaretDoubleRight,
    CaretLeft,
    CaretRight,
} from "@phosphor-icons/react";
import FormDropdown, { FormDropdownOption } from "./FormDropdown";
import IconButton from "./IconButton";
import Typography from "./Typography";

export type PaginationProps = {
    setPageNumber: (value: ((currentValue: number) => number) | number) => void;
    pageSize: number;
    setPageSize: (value: ((currentValue: number) => number) | number) => void;
    totalCount: number;
    totalPages: number;
    pageNumber: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
};

const pageSizeOptions = [15, 25, 50, 75, 100];

const options: FormDropdownOption<number>[] = pageSizeOptions.map(
    (o: number) => ({
        label: o.toString(),
        value: o,
    })
);

const Pagination: React.FC<PaginationProps> = ({
    setPageNumber,
    pageSize,
    setPageSize,
    totalCount,
    totalPages,
    pageNumber,
    hasPreviousPage = true,
    hasNextPage = true,
}) => {
    const firstPageIndex = 0;
    const displayPageNumber = pageNumber + 1;

    const handlePageSizeSelect = (value: number) => {
        setPageSize(value);
        setPageNumber(firstPageIndex);
    };

    const firstRow = pageSize * pageNumber + 1;
    let lastRow = displayPageNumber * pageSize;

    if (displayPageNumber === totalPages) {
        lastRow = totalCount;
    }

    return (
        <div className="flex sm:flex-row flex-col justify-end py-2 gap-7 items-center text-sm">
            <div className="flex flex-row justify-end py-2 gap-7 items-center text-sm">
                <Typography variant="body-medium" component="p">
                    Rows per page
                </Typography>
                <FormDropdown
                    className="w-24 font-bold"
                    options={options}
                    value={pageSize}
                    onChange={handlePageSizeSelect}
                    inputClassName="rounded-xl h-12"
                />
                <Typography variant="body-medium" component="p">
                    {firstRow} - {lastRow} of {totalCount}
                </Typography>
            </div>
            <div className="flex flex-row justify-end py-2 gap-3 items-center text-sm">
                <IconButton
                    icon={CaretDoubleLeft}
                    label="First page"
                    onClick={() => setPageNumber(0)}
                    disabled={!hasPreviousPage}
                />
                <IconButton
                    icon={CaretLeft}
                    label="Previous page"
                    onClick={() => setPageNumber((current) => current - 1)}
                    disabled={!hasPreviousPage}
                />
                <IconButton
                    icon={CaretRight}
                    label="Next page"
                    onClick={() => setPageNumber((current) => current + 1)}
                    disabled={!hasNextPage}
                />
                <IconButton
                    icon={CaretDoubleRight}
                    label="Last page"
                    onClick={() => setPageNumber(totalPages - 1)}
                    disabled={!hasNextPage}
                />
            </div>
        </div>
    );
};

export default Pagination;
